export default {
  title: 'Jaarcontractkorting',
  buttons: {
    edit: 'Korting bewerken',
    save: 'Korting opslaan',
  },
  toasts: {
    invalid_discount: 'De jaarcontractkorting moet tussen {{min}}% en {{max}}% liggen',
  },
};
